const faqItems = [
  {
    q: '妖精漫画网是否需要注册才能阅读？',
    a: '不需要。妖精漫画网所有漫画内容完全免费开放，无需注册或登录即可直接在线阅读，方便快捷。',
  },
  {
    q: '网站上的漫画多久更新一次？',
    a: '我们与作者保持密切合作，热门连载作品每日稳定更新，部分作品每周固定更新多话，确保读者追更体验不断档。',
  },
  {
    q: '支持哪些设备阅读漫画？',
    a: '妖精漫画网全面适配桌面端、平板和手机浏览器，无论使用什么设备都能获得流畅的下拉式阅读体验。',
  },
  {
    q: '如何找到我想看的漫画类型？',
    a: '您可以通过首页的专题合集、热门排行以及话题标签快速定位感兴趣的漫画，也可以使用站内搜索功能。',
  },
  {
    q: '漫画加载速度如何？',
    a: '平台采用高性能服务器和图片优化技术，确保漫画页面快速加载，下拉式阅读模式下图片预加载让追更体验丝滑流畅。',
  },
  {
    q: '我是漫画作者，如何投稿合作？',
    a: '欢迎优秀漫画创作者！您可以通过本页联系入口中的邮箱或官方渠道与我们取得联系，提交作品进行合作洽谈。',
  },
];

export default function FaqSection() {
  return (
    <section id="faq" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-3xl mx-auto">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 text-center mb-3">
          常见问题
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10 md:mb-14">
          关于妖精漫画网阅读与使用的常见疑问解答
        </p>

        <div className="space-y-3">
          {faqItems.map((item, i) => (
            <details
              key={i}
              className="group rounded-xl bg-background-50 border border-background-200 overflow-hidden"
              open
            >
              <summary className="flex items-center justify-between px-5 py-4 cursor-pointer hover:bg-background-100 transition-colors list-none">
                <h3 className="font-heading text-sm md:text-base font-semibold text-foreground-900 pr-4">
                  {item.q}
                </h3>
                <span className="w-5 h-5 flex-shrink-0 flex items-center justify-center text-foreground-400 group-open:hidden">
                  <i className="ri-add-line"></i>
                </span>
                <span className="w-5 h-5 flex-shrink-0 items-center justify-center text-foreground-400 hidden group-open:flex">
                  <i className="ri-subtract-line"></i>
                </span>
              </summary>
              <div className="px-5 pb-4">
                <p className="text-sm text-foreground-600 leading-relaxed">{item.a}</p>
              </div>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}